import { render, staticRenderFns } from "./ManageAccount.vue?vue&type=template&id=4dc88b79&scoped=true&"
import script from "./ManageAccount.vue?vue&type=script&lang=ts&"
export * from "./ManageAccount.vue?vue&type=script&lang=ts&"
import style0 from "./ManageAccount.vue?vue&type=style&index=0&id=4dc88b79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc88b79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle})
